import script from "./newsTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./newsTemplate.vue?vue&type=script&setup=true&lang=js"

import "./newsTemplate.vue?vue&type=style&index=0&id=639afd0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639afd0a"]])

export default __exports__